import { render, staticRenderFns } from "./VoteList.vue?vue&type=template&id=a11516de&scoped=true&"
import script from "./VoteList.vue?vue&type=script&lang=ts&"
export * from "./VoteList.vue?vue&type=script&lang=ts&"
import style0 from "./VoteList.vue?vue&type=style&index=0&id=a11516de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11516de",
  null
  
)

export default component.exports